import './style.css';

const Campanha = ({ descricao, banner, inicio, fim, link }) => {
    // Valida se o banner tem um nome de arquivo válido
    const bannerValido = banner && banner !== '' && !banner.endsWith('/');
    
    return (
      <div className="campanha">
        {bannerValido && <img src={banner} alt={descricao} className="d-block custom-img" />}
        <div className="carousel-caption">
          <h3>{descricao}</h3>
          <p>Início: {inicio} - Fim: {fim}</p>
          { link && <a href={link} className="btn btn-primary">Saiba mais</a>}
        </div>
      </div>
    );
  };
  
  export default Campanha;